import angular from 'angular';

import externalRedirect from 'app/common/services/externalRedirect';
import loginFormComponent from './components/form/loginFormComponent';
import loginHeaderComponent from './components/header/loginHeaderComponent';
import loginService from './components/form/loginService';
import LoginComponent from './login.component';

const moduleName = 'login';

angular
    .module(moduleName, [])
    .factory('externalRedirect', externalRedirect)
    .factory('loginService', loginService)
    .component('loginForm', loginFormComponent)
    .component('loginHeader', loginHeaderComponent)
    .component('login', LoginComponent);

export default moduleName;







/** WEBPACK FOOTER **
 ** ./src/main/assets/app/login/login.module.js
 **/